/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    Filter = require('../models/filter'),
    configuration = require('../utilities/configuration'),
    EOL = null;

module.exports = Backbone.Collection.extend({
    model: Filter,
    //
    getFilterSet: function () {
        const o = {};
        _.each(this.models, function (model) {
            const m = model.toJSON();
            o[m.group] = m.values;
        });
        return o;
    }
    // parse: function (results, options) {
    //     // console.log('filters.parse - results:%s', JSON.stringify(results));
    //     return results;
    // }
});
